// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"46":"splide","236":"fcsuggest","275":"promobox","327":"cruiseoffers","394":"fastbooking"}[chunkId] || chunkId) + ".js";
};